export const APP_ERROR_EVENT = 'rae-pm:app-error';

export function notifyAppError(message: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(APP_ERROR_EVENT, { detail: { message } }));
}
